import { render } from "./Karte.vue?vue&type=template&id=fc610ba8&bindings={}"
import script from "./Karte.vue?vue&type=script&lang=js"
export * from "./Karte.vue?vue&type=script&lang=js"

import "./Karte.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script